module.exports = __webpack_public_path__ + "4e71ab58d39d69c5c263a14298e9a496.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/blocks.png
// module id = 3352
// module chunks = 0